import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'wonderbly-components/lib/Panel';
import Icon from 'wonderbly-components/lib/Icon';
import { replaceTextWithValues } from 'src/common/utils/text-replace';
import RichText from '../../Prismic/RichText';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import './CreditInfo.scss';

const CreditInfo = props => (
  <section className="credit-info-partial">
    <a href={`${localiseUrl(props.country, '/account/credit')}`} className="container-guttered">
      <Panel border="shadow">
        {props.icon && <Icon icon={props.icon} />}
        <RichText fields={[{
          type: 'heading5',
          text: replaceTextWithValues(props.creditInfoText, { credit: props.credit.formatted }),
        }]}
        />
        <p className="text-base">{props.linkText}</p>
      </Panel>
    </a>
  </section>
);


CreditInfo.propTypes = {
  creditInfoText: PropTypes.string.isRequired,
  linkText: PropTypes.stisRequiredring,
  icon: PropTypes.string,
  credit: PropTypes.shape({
    formatted: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
  }).isRequired,
  country: PropTypes.object.isRequired,
};

export default CreditInfo;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Account/CreditInfo/CreditInfo.js